import { ProfessionIcon } from './profession-icon';

export const IconElectrician = () => (
  <ProfessionIcon bg="#FFF8E1">
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"
        fill="#F59E0B"
        stroke="#F59E0B"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  </ProfessionIcon>
);
